import classnames from 'classnames';

export default function InfoBlock({ children, className }) {
  return (
    <div
      className={classnames(
        'border-l-4 border-cornflower bg-whisper text-haiti px-6 py-px rounded',
        className,
      )}
    >
      {children}
    </div>
  );
}
